/* Turf Care Pro — product page v4 (16-10-2026). Vanilla JS, no library. */
(function () {
  'use strict';
  var GBP = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var NUM = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 });
  var KG = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 });
  function money(c) { return GBP.format(c / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
  function json(root, sel) { var n = root.querySelector(sel); if (!n) return null; try { return JSON.parse(n.textContent); } catch (e) { return null; } }
  function cartChanged() {
    ['cart:refresh', 'cart:update', 'cart-update'].forEach(function (t) { document.dispatchEvent(new CustomEvent(t, { bubbles: true })); });
  }
  function addLines(items) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); cartChanged(); return j; }); });
  }

  /* ---------- sticky offset: the theme header is sticky, so the gallery and the tab bar sit just under it ---------- */
  function stickyTop() {
    var h = document.querySelector('.ch-header, header-component, #header-group .shopify-section');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') {
      var inner = h.querySelector && h.querySelector('[style*="position"], .ch-header');
      if (!inner) return 0;
      h = inner; cs = getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    }
    var r = h.getBoundingClientRect();
    if (r.bottom <= 0 || cs.visibility === 'hidden') return 0;
    return Math.max(0, Math.round(r.bottom));
  }

  function init(root) {
    if (root.__tpd) return; root.__tpd = true;
    var product = json(root, '[data-tpd-product]') || { variants: [] };
    var label = json(root, '[data-tpd-label]');
    var seed = json(root, '[data-tpd-seed]');
    var bags = json(root, '[data-tpd-bags]') || {};
    var form = root.querySelector('[data-tpd-form]');
    var idIn = root.querySelector('[data-tpd-id]');
    var qtyIn = root.querySelector('[data-tpd-qty]');
    var priceEl = root.querySelector('[data-tpd-price]');
    var vatLbl = root.querySelector('[data-tpd-vatlbl]');
    var msg = root.querySelector('[data-tpd-msg]');
    var cert = root.querySelector('[data-tpd-cert]');
    var certBox = root.querySelector('[data-tpd-certbox]');
    var buy = root.querySelector('[data-tpd-buy]');
    var bar = root.querySelector('[data-tpd-bar]');

    var current = product.variants.filter(function (v) { return String(v.id) === idIn.value; })[0] || product.variants[0];
    function kgOf(v) { return v ? (Number(bags[String(v.id)]) || 0) : 0; }

    /* ---------- sticky offset ---------- */
    var lastTop = -1;
    function paintTop() {
      var t = stickyTop();
      if (t !== lastTop) { lastTop = t; root.style.setProperty('--tpd-sticky-top', t + 'px'); }
    }
    var topTick = false;
    function onScroll() { if (topTick) return; topTick = true; requestAnimationFrame(function () { topTick = false; paintTop(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paintTop(); setTimeout(paintTop, 300); setTimeout(paintTop, 1200);

    /* ---------- price (shown once, in the buy card) ---------- */
    function paintPrice() {
      if (!current) return;
      priceEl.textContent = money(current.price);
      vatLbl.textContent = current.taxable === false ? 'no VAT' : 'incl. VAT';
    }

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-tpd-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tpd-th]'));
    var count = root.querySelector('[data-tpd-count]');
    function go(i) { if (!track || !slides[i]) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); if (k === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } });
      if (count) count.textContent = (i + 1) + ' of ' + slides.length;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-tpd-th'); go(i); mark(i); }); });
    if (track) {
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); mark(Math.max(0, Math.min(slides.length - 1, i))); }, 60); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
      });
    }

    /* ---------- variants ---------- */
    var optInputs = Array.prototype.slice.call(root.querySelectorAll('[data-tpd-opt]'));
    function packFor(v) {
      if (!label) return null;
      if (label.packs && v) { var k = String(v.title || '').replace(/\s+/g, '').toLowerCase(); if (label.packs[k] != null) return label.packs[k]; }
      return label.pack;
    }
    /* ---------- stock: a sold-out variant cannot be added (buttons read "Sold out" and are disabled) ---------- */
    var soldOut = false;
    function paintStock(v) {
      soldOut = !!v && v.available === false;
      var bb = bar ? bar.querySelector('[data-tpd-baradd]') : null;
      [addBtn, nowBtn, bb].forEach(function (b) {
        if (!b) return;
        b.disabled = soldOut;
        b.classList.toggle('is-soldout', soldOut);
        b.style.opacity = soldOut ? '.55' : '';
        b.style.cursor = soldOut ? 'not-allowed' : '';
      });
      if (addBtn) { if (addBtn.__tpdLbl == null) addBtn.__tpdLbl = addBtn.innerHTML; addBtn.innerHTML = soldOut ? 'Sold out' : addBtn.__tpdLbl; }
      if (bb) { if (bb.__tpdLbl == null) bb.__tpdLbl = bb.textContent; bb.textContent = soldOut ? 'Sold out' : bb.__tpdLbl; }
      /* fade every option value that has no in-stock variant with the other current choices */
      function valueSold(k, val) {
        return !product.variants.some(function (x) {
          return x.available !== false && x.options[k] === val && x.options.every(function (o, j) { return j === k || !v || o === v.options[j]; });
        });
      }
      optInputs.forEach(function (i) {
        var lab = i.closest('label') || i.parentElement; if (!lab) return;
        var so = valueSold(+i.getAttribute('data-tpd-opt'), i.value);
        lab.classList.toggle('is-soldout', so);
        lab.style.opacity = so ? '.45' : '';
        if (so) lab.setAttribute('title', 'Sold out'); else lab.removeAttribute('title');
      });
      root.querySelectorAll('[data-tpd-barval]').forEach(function (b) {
        var so = valueSold(0, b.getAttribute('data-tpd-barval'));
        b.style.opacity = so ? '.45' : '';
      });
    }
    function paintVariant() {
      var v = current; if (!v) return;
      idIn.value = v.id; paintPrice(); paintStock(v);
      var sku = root.querySelector('[data-tpd-sku]'), skr = root.querySelector('[data-tpd-skurow]');
      if (sku) { sku.textContent = v.sku || ''; skr.hidden = !v.sku; }
      var per = root.querySelector('[data-tpd-per]'), peru = root.querySelector('[data-tpd-perunit]');
      if (per && peru) {
        var kg = kgOf(v);
        if (kg > 0) { peru.textContent = kg + ' kg bag'; per.hidden = false; }
        else if (label) { peru.textContent = (product.variants.length > 1 ? v.title : (label.pack_txt || '')) + ' pack'; per.hidden = !(label.pack_txt || product.variants.length > 1); }
        else { per.hidden = true; }
      }
      root.querySelectorAll('[data-tpd-optsel]').forEach(function (e) { var k = +e.getAttribute('data-tpd-optsel'); e.textContent = (v.options[k] || '') + ' selected' + (v.available === false ? ' (sold out)' : ''); });
      var bv = root.querySelector('[data-tpd-barvar]'); if (bv) bv.textContent = v.title;
      root.querySelectorAll('[data-tpd-barval]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-tpd-barval') === v.options[0]); });
      root.querySelectorAll('[data-tpd-specrow]').forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-tpd-specrow') === String(v.id)); });
      if (v.featured_media) { slides.forEach(function (s, k) { if (s.getAttribute('data-media') === String(v.featured_media.id)) { go(k); mark(k); } }); }
      if (root.__tpdPainted) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {} }
      root.__tpdPainted = true;
      calc(); seedCalc();
    }
    function onVariant() {
      var sel = [];
      optInputs.forEach(function (i) { if (i.checked) sel[+i.getAttribute('data-tpd-opt')] = i.value; });
      var v = product.variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
      if (!v) { msg.textContent = 'That combination is not available.'; msg.className = 'tpd-msg is-err'; return; }
      msg.textContent = ''; msg.className = 'tpd-msg';
      current = v; paintVariant();
    }
    optInputs.forEach(function (i) { i.addEventListener('change', onVariant); });
    root.querySelectorAll('[data-tpd-barval]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.getAttribute('data-tpd-barval');
        optInputs.forEach(function (i) { if (i.getAttribute('data-tpd-opt') === '0' && i.value === val) { i.checked = true; } });
        onVariant();
      });
    });

    /* ---------- quantity (buy card + sticky bar share it) ---------- */
    function setQty(n) { n = Math.max(1, Math.min(9999, parseInt(n, 10) || 1)); qtyIn.value = n; root.querySelectorAll('[data-tpd-barqty]').forEach(function (b) { b.textContent = n; }); }
    root.querySelectorAll('[data-tpd-step]').forEach(function (b) { b.addEventListener('click', function () { setQty((parseInt(qtyIn.value, 10) || 1) + (+b.getAttribute('data-tpd-step'))); }); });
    qtyIn.addEventListener('change', function () { setQty(qtyIn.value); });

    /* ---------- add / buy now ---------- */
    function certOk() {
      if (!cert || cert.checked) { if (certBox) certBox.classList.remove('is-err'); return true; }
      certBox.classList.add('is-err');
      msg.textContent = 'Please confirm the product will be applied by a certificate holder.'; msg.className = 'tpd-msg is-err';
      cert.focus();
      return false;
    }
    if (cert) cert.addEventListener('change', function () { if (cert.checked) { certBox.classList.remove('is-err'); if (/certificate/.test(msg.textContent)) { msg.textContent = ''; msg.className = 'tpd-msg'; } } });
    function item() {
      var it = { id: +idIn.value, quantity: parseInt(qtyIn.value, 10) || 1 };
      if (cert) it.properties = { _Professional_use_confirmed: 'Yes' };
      return it;
    }
    var addBtn = root.querySelector('[data-tpd-add]'), nowBtn = root.querySelector('[data-tpd-now]');
    function busy(on) { [addBtn, nowBtn].forEach(function (b) { if (b) b.disabled = on || soldOut; }); }
    function doAdd(thenCheckout) {
      if (soldOut) { msg.textContent = 'This size is sold out.'; msg.className = 'tpd-msg is-err'; buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); return Promise.reject(new Error('sold out')); }
      if (!certOk()) { buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); return Promise.reject(new Error('cert')); }
      busy(true); msg.textContent = thenCheckout ? 'Taking you to checkout…' : 'Adding…'; msg.className = 'tpd-msg';
      return addLines([item()]).then(function () {
        if (thenCheckout) { location.href = '/checkout'; return; }
        var n = parseInt(qtyIn.value, 10) || 1;
        msg.innerHTML = 'Added ' + esc(n) + ' to your basket. <a href="/cart">View basket</a>';
      }).catch(function (e) { msg.textContent = e.message; msg.className = 'tpd-msg is-err'; throw e; })
        .then(function () { busy(false); }, function (e) { busy(false); throw e; });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(false).catch(function () {}); });
    if (nowBtn) nowBtn.addEventListener('click', function () { doAdd(true).catch(function () {}); });

    /* ---------- label-rate calculator (plant protection products) ---------- */
    var area = root.querySelector('[data-tpd-calc] [data-tpd-area]');
    var useBtn = root.querySelector('[data-tpd-calc] [data-tpd-usepacks]');
    var packsNeeded = 1;
    function amount(x, unit) {
      if (unit === 'ml') return x >= 1000 ? (Math.round(x / 10) / 100).toLocaleString('en-GB') + ' L' : NUM.format(x) + ' ml';
      return x >= 1000 ? (Math.round(x / 10) / 100).toLocaleString('en-GB') + ' kg' : NUM.format(x) + ' g';
    }
    function calc() {
      if (!label) return;
      var pack = packFor(current) || label.pack;
      var cov = root.querySelector('[data-tpd-cov]');
      if (cov) cov.textContent = NUM.format(pack * 10000 / label.rate) + ' m²';
      if (!area) return;
      var n = Number(area.value); if (!isFinite(n) || n < 0) n = 0;
      var prod = n * label.rate / 10000;
      var w = label.water || [];
      var lo = w[0] ? n * w[0] / 10000 : 0, hi = w[1] ? n * w[1] / 10000 : 0;
      root.querySelector('[data-tpd-o="product"]').textContent = amount(prod, label.unit);
      root.querySelector('[data-tpd-o="water"]').textContent = hi ? NUM.format(lo) + '–' + NUM.format(hi) + ' L' : (lo ? NUM.format(lo) + ' L+' : '–');
      packsNeeded = n > 0 ? Math.ceil(prod / pack - 1e-9) : 0;
      root.querySelector('[data-tpd-o="packs"]').textContent = packsNeeded;
      useBtn.textContent = 'Set quantity to ' + Math.max(1, packsNeeded) + (Math.max(1, packsNeeded) === 1 ? ' pack' : ' packs');
      root.querySelectorAll('[data-tpd-calc] [data-tpd-preset]').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-tpd-preset') === n); });
    }
    if (area && label) {
      area.addEventListener('input', calc);
      root.querySelectorAll('[data-tpd-calc] [data-tpd-preset]').forEach(function (b) { b.addEventListener('click', function () { area.value = b.getAttribute('data-tpd-preset'); calc(); }); });
      useBtn.addEventListener('click', function () {
        setQty(Math.max(1, packsNeeded));
        buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
        msg.textContent = 'Quantity set to ' + Math.max(1, packsNeeded) + '.'; msg.className = 'tpd-msg';
      });
    }

    /* ---------- seed calculator: area × rate -> kg -> bags of the selected size ---------- */
    var sc = root.querySelector('[data-tpd-seedcalc]');
    var scMode = 'new', scArea = 'm2', scBags = 1;
    function seedCalc() {
      if (!sc || !seed) return;
      var rateIn = sc.querySelector('[data-tpd-rate]');
      var rng = scMode === 'over' && seed.rate_over ? seed.rate_over : seed.rate_new;
      if (String(rateIn.min) !== String(rng[0]) || String(rateIn.max) !== String(rng[1])) {
        rateIn.min = rng[0]; rateIn.max = rng[1]; rateIn.value = Math.round((rng[0] + rng[1]) / 2);
        var hint = sc.querySelector('[data-tpd-ratehint]');
        if (hint) hint.textContent = (scMode === 'over' ? 'Overseeding rate for this mixture: ' : 'Sowing rate for this mixture: ') + (scMode === 'over' ? seed.rate_over_txt : seed.rate_new_txt) + ' g/m²';
      }
      rateIn.disabled = rng[0] === rng[1];
      var rate = Number(rateIn.value) || rng[0];
      sc.querySelector('[data-tpd-rateval]').textContent = rate;
      var a;
      if (scArea === 'lw') {
        var l = Number(sc.querySelector('[data-tpd-len]').value) || 0, w = Number(sc.querySelector('[data-tpd-wid]').value) || 0;
        a = l * w;
      } else { a = Number(sc.querySelector('[data-tpd-area]').value) || 0; }
      if (a < 0) a = 0;
      var need = a * rate / 1000;
      sc.querySelector('[data-tpd-need]').textContent = need >= 1000 ? KG.format(need / 1000) + ' t' : KG.format(need) + ' kg';
      sc.querySelector('[data-tpd-eq]').textContent = NUM.format(a) + ' m² × ' + rate + ' g/m² (' + (scMode === 'over' ? 'overseeding' : (/wildflower/i.test(product.type || '') ? 'new sowing' : 'new lawn')) + ')';
      sc.querySelectorAll('[data-tpd-preset]').forEach(function (b) { b.classList.toggle('is-on', scArea === 'm2' && +b.getAttribute('data-tpd-preset') === a); });
      var out = sc.querySelector('[data-tpd-bagsout]'); out.innerHTML = '';
      var curKg = kgOf(current), curBags = 0;
      var sizes = product.variants.map(function (v) { return { v: v, kg: kgOf(v) }; }).filter(function (s) { return s.kg > 0; });
      sizes.sort(function (x, y) { return x.kg - y.kg; });
      sizes.forEach(function (s) {
        var n = need > 0 ? Math.ceil(need / s.kg - 1e-9) : 0;
        if (s.v.id === current.id) curBags = n;
        var row = document.createElement('div');
        row.className = 'tpd-bagrow' + (s.v.id === current.id ? ' is-on' : '');
        row.innerHTML = '<b>' + n + ' ×</b> <span>' + s.kg + ' kg bag' + (n === 1 ? '' : 's') + '</span>' + (s.v.id === current.id ? '<small>selected size</small>' : '');
        out.appendChild(row);
      });
      var left = sc.querySelector('[data-tpd-leftover]');
      if (curKg > 0 && curBags > 0) {
        var over = curBags * curKg - need;
        if (over > 0.05) {
          var r2 = seed.rate_over ? seed.rate_over[1] : rate;
          left.textContent = 'Left over: ' + KG.format(over) + ' kg — enough to ' + (seed.rate_over ? 'overseed about ' + NUM.format(over * 1000 / r2) + ' m² of thin patches later at ' + r2 + ' g/m².' : 'sow about ' + NUM.format(over * 1000 / r2) + ' m² more at ' + r2 + ' g/m².');
          left.classList.add('is-on');
        } else { left.classList.remove('is-on'); }
      } else { left.classList.remove('is-on'); }
      scBags = Math.max(1, curBags);
      var ut = sc.querySelector('[data-tpd-usetxt]');
      if (ut) ut.textContent = 'Add ' + scBags + ' bag' + (scBags === 1 ? '' : 's') + (curKg > 0 ? ' (' + curKg + ' kg)' : '') + ' to basket';
    }
    if (sc && seed) {
      sc.querySelectorAll('[data-tpd-mode]').forEach(function (b) { b.addEventListener('click', function () { scMode = b.getAttribute('data-tpd-mode'); sc.querySelectorAll('[data-tpd-mode]').forEach(function (x) { x.classList.toggle('is-on', x === b); }); seedCalc(); }); });
      sc.querySelectorAll('[data-tpd-amode]').forEach(function (b) { b.addEventListener('click', function () {
        scArea = b.getAttribute('data-tpd-amode');
        sc.querySelectorAll('[data-tpd-amode]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        sc.querySelector('[data-tpd-m2]').classList.toggle('is-on', scArea === 'm2'); sc.querySelector('[data-tpd-lw]').classList.toggle('is-on', scArea === 'lw');
        seedCalc();
      }); });
      ['[data-tpd-area]', '[data-tpd-len]', '[data-tpd-wid]', '[data-tpd-rate]'].forEach(function (s) { var e = sc.querySelector(s); if (e) e.addEventListener('input', seedCalc); });
      sc.querySelectorAll('[data-tpd-preset]').forEach(function (b) { b.addEventListener('click', function () {
        scArea = 'm2'; sc.querySelectorAll('[data-tpd-amode]').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-tpd-amode') === 'm2'); });
        sc.querySelector('[data-tpd-m2]').classList.add('is-on'); sc.querySelector('[data-tpd-lw]').classList.remove('is-on');
        sc.querySelector('[data-tpd-area]').value = b.getAttribute('data-tpd-preset'); seedCalc();
      }); });
      var scBtn = sc.querySelector('[data-tpd-usepacks]');
      scBtn.addEventListener('click', function () {
        setQty(scBags);
        var t = sc.querySelector('[data-tpd-usetxt]'), was = t.textContent;
        scBtn.disabled = true; t.textContent = 'Adding…';
        doAdd(false).then(function () { t.textContent = 'Added to basket ✓'; setTimeout(function () { t.textContent = was; scBtn.disabled = false; }, 2200); })
          .catch(function () { t.textContent = was; scBtn.disabled = false; buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      });
    }

    /* ---------- "For the same job" quick add ---------- */
    root.querySelectorAll('[data-tpd-quick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.textContent; b.disabled = true; b.textContent = 'Adding…';
        addLines([{ id: +b.getAttribute('data-tpd-quick'), quantity: 1 }])
          .then(function () { b.textContent = 'Added ✓'; setTimeout(function () { b.textContent = t; b.disabled = false; }, 1800); })
          .catch(function () { b.textContent = t; b.disabled = false; location.href = b.closest('.tpd-pc').querySelector('a').href; });
      });
    });

    /* ---------- tabs: the panels swap in place (fade), the page does not scroll ---------- */
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-tpd-tabs] a'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.tpd-panel'));
    var tabsBar = root.querySelector('[data-tpd-tabsbar]');
    function showTab(id, scrollTo) {
      var target = root.querySelector('#' + id);
      if (!target || !target.classList.contains('tpd-panel')) return false;
      panels.forEach(function (pn) { pn.classList.toggle('is-on', pn === target); });
      links.forEach(function (a) { var on = a.getAttribute('href') === '#' + id; a.classList.toggle('is-on', on); a.setAttribute('aria-selected', String(on)); });
      if (scrollTo && tabsBar) {
        var y = tabsBar.getBoundingClientRect().top + window.pageYOffset - stickyTop() - 4;
        if (tabsBar.getBoundingClientRect().top < stickyTop() - 2 || tabsBar.getBoundingClientRect().top > window.innerHeight - 80) window.scrollTo({ top: y, behavior: 'smooth' });
      }
      return true;
    }
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
        if (!root.querySelector('#' + id)) return;
        e.preventDefault();
        showTab(id, true);
        try { history.replaceState(history.state, '', '#' + id); } catch (err) {}
        var on = links.filter(function (x) { return x.classList.contains('is-on'); })[0];
        if (on && on.scrollIntoView) { try { on.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (err2) {} }
      });
    });
    /* in-page links to a panel (e.g. "Work out how many bags you need") open that tab and bring the tab bar into view */
    root.querySelectorAll('a[href^="#tpd-"]:not([data-tpd-tabs] a)').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var t = root.querySelector('#' + id);
        if (t && t.classList.contains('tpd-panel')) { e.preventDefault(); showTab(id, false); var y = tabsBar.getBoundingClientRect().top + window.pageYOffset - stickyTop() - 4; window.scrollTo({ top: y, behavior: 'smooth' }); }
      });
    });
    if (location.hash && /^#tpd-/.test(location.hash)) { showTab(location.hash.slice(1), false); }

    /* ---------- sticky bar: only once the buy card has scrolled away ---------- */
    if (bar && 'IntersectionObserver' in window) {
      var bio = new IntersectionObserver(function (ents) {
        var off = !ents[0].isIntersecting && ents[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', off); bar.setAttribute('aria-hidden', String(!off));
        bar.querySelectorAll('button').forEach(function (bb) { bb.tabIndex = off ? 0 : -1; });
      });
      bio.observe(buy);
      bar.querySelector('[data-tpd-baradd]').addEventListener('click', function () {
        if (soldOut) return;
        if (cert && !cert.checked) { buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); certOk(); return; }
        var bb = bar.querySelector('[data-tpd-baradd]'), was = bb.textContent; bb.disabled = true; bb.textContent = 'Adding…';
        doAdd(false).then(function () { bb.textContent = 'Added ✓'; setTimeout(function () { bb.textContent = was; bb.disabled = soldOut; }, 1800); })
          .catch(function () { bb.textContent = was; bb.disabled = soldOut; buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      });
    }

    /* ---------- quote dialog (product-specific) ---------- */
    var dlg = root.querySelector('[data-tpd-dlg]'), qbtn = root.querySelector('[data-tpd-quote]');
    if (dlg && qbtn) {
      var lastFocus = null;
      var openDlg = function () {
        var qv = dlg.querySelector('[data-tpd-qvar]'); if (qv && current && current.title !== 'Default Title') qv.value = current.title + (current.sku ? ' (SKU ' + current.sku + ')' : '');
        var qq = dlg.querySelector('[data-tpd-qqty]'); if (qq && !qq.value) qq.value = qtyIn.value;
        lastFocus = document.activeElement;
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        var f = dlg.querySelector('input[name="contact[name]"]'); if (f) f.focus();
      };
      var closeDlg = function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); if (lastFocus) lastFocus.focus(); };
      qbtn.addEventListener('click', openDlg);
      dlg.querySelector('[data-tpd-dlgclose]').addEventListener('click', closeDlg);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(); });
      if (/contact_posted=true/.test(location.search) || location.hash === '#tpd-quote-form' || dlg.querySelector('.tpd-qf__err')) { openDlg(); }
    }

    setQty(qtyIn.value);
    paintVariant();
  }

  function boot() { document.querySelectorAll('[data-tpd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
/* Recently viewed: remembers the last 8 product handles for the empty-basket page. Per browser only. */
(function () {
  try {
    var n = document.querySelector('[data-tpd-product]'); if (!n) return;
    var h = JSON.parse(n.textContent).handle; if (!h) return;
    var l = JSON.parse(localStorage.getItem('tcpRecent') || '[]'); if (!Array.isArray(l)) l = [];
    l = [h].concat(l.filter(function (x) { return x !== h; })).slice(0, 8);
    localStorage.setItem('tcpRecent', JSON.stringify(l));
  } catch (e) {}
})();
